import { EditButton, TopToolbar, useGetIdentity, useRedirect } from 'react-admin'
import DeleteWithConfirmationButton from './DeleteWithConfirmationButton'
import EmailServiceConfigTestButton from './EmailServiceConfigTestButton'

const MailServerShowActions = () => {
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <TopToolbar sx={{justifyContent:"flex-start"}}>
      <EmailServiceConfigTestButton userId={identity.id.toString()} />
      <EditButton onClick={(e) => {
        e.preventDefault()
        redirect(`/users/${identity.id}/mailServiceConfig/edit`)
      }}/>
      <DeleteWithConfirmationButton userId={identity.id.toString()} />
    </TopToolbar>
  )
}

export default MailServerShowActions